module.exports = __webpack_public_path__ + "static/media/img-destaque-home.f24ef1be.jpg";